<template>
  <b-container fluid>
    <hr />
    <b-row class="my-2">
      <b-col md="4">
        <b-form-group
          label="Filter"
          label-for="filter-input"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              placeholder="Type to Search"
            ></b-form-input>

            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''"
                >Clear</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col md="3" offset="4">
        <b-form-group
          horizontal
          label="Sort"
          class="mb-0"
          label-size="sm"
          label-cols="1"
        >
          <b-input-group>
            <b-form-select v-model="sortBy" :options="sortOptions" size="sm">
              <option slot="first" :value="null">-- none --</option>
            </b-form-select>
            <b-input-group-append>
              <b-form-select :disabled="!sortBy" v-model="sortDesc" size="sm">
                <option :value="false">Asc</option>
                <option :value="true">Desc</option>
              </b-form-select>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col md="1">
        <p class="float-right">
          <small> Rows: {{ totalRows }} </small>
        </p>
      </b-col>
    </b-row>
    <b-table
      :items="items"
      :fields="fields"
      striped
      hover
      small
      boardered
      head-variant="dark"
      :current-page="currentPage"
      :per-page="perPage"
      responsive
      :busy="isBusy"
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      stacked="md"
      @filtered="onFiltered"
      style="font-size: 12px"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <template #cell(history)="row">
        <b-button
          size="sm"
          variant="primary"
          @click="showCallHistory(row.item)"
        >
          <b-icon icon="telephone-outbound" aria-hidden="true"></b-icon>
        </b-button>
      </template>
      <template #cell(action)="row">
        <b-button
          size="sm"
          variant="warning"
          @click="caseDetails(row.item, row.index)"
        >
          <b-icon icon="person-fill" aria-hidden="true"></b-icon>
        </b-button>
      </template>
    </b-table>
    <b-row>
      <b-col sm="6" md="2" class="my-1">
        <b-form-group
          label="Per page"
          label-cols="6"
          label-align-sm="right"
          label-size="sm"
          label-for="perPageSelect"
          class="mb-0"
        >
          <b-form-select
            v-model="perPage"
            id="perPageSelect"
            size="sm"
            :options="pageOptions"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col></b-col>
      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="right"
          size="sm"
          pills
          last-number
        ></b-pagination>
      </b-col>
    </b-row>
    <b-modal id="mdlHistory" ref="mdlHistory" size="lg">
      <b-table
        striped
        hover
        :items="callHistory"
        :fields="callHistoryFields"
      ></b-table>
    </b-modal>
  </b-container>
</template>
<script>
import apis from "@/apis";

export default {
  props: ["positiveResponse", "lastResponse"],
  data() {
    return {
      callType: "",
      perPage: 10,
      pageOptions: [10, 20, 50, 100],
      totalRows: 0,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      isBusy: true,
      fields: [
        { key: "history", label: "Last Calls" },
        { key: "action", label: "Details" },
      ],
      items: [],
      callHistory: [],
      callHistoryFields: ["callDate", "callFeedBack", "callResponse", "caller"],
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
      this.$session.set("filterList", filteredItems);
      this.$session.set("filter", this.filter);
    },
    showCallHistory(item) {
      let id = item._id;
      let promise = apis.getHistory(id, this.$store.getters.currentProcess);
      promise
        .then((response) => {
          if (response.status == 200) {
            this.callHistory = response.body.callHistory;
            this.$refs["mdlHistory"].show();
          }
        })
        .catch((err) => {
          alert("Error!!");
        });
    },
    caseDetails(item, index) {
      let indx = (this.currentPage - 1) * this.perPage + index;
      this.$session.set("index", indx);
      this.$router.push({ name: "CaseDetails", params: { id: item._id } });
    },
    loadCallList() {
      let payLoad = {
        userid: this.$store.getters.loggedUser.userName,
        callType: this.lastResponse,
        processName: this.$store.getters.currentProcess,
        priorityNum: this.$store.getters.currentPriority,
        positiveResponse: this.positiveResponse,
      };
      //alert(JSON.stringify(payLoad));
      let promise = apis.getCallList(payLoad);
      promise
        .then((response) => {
          if (response.status == 200) {
            this.items = response.data.data;
            this.$session.set("callList", this.items);
            var elmt;
            for (elmt in response.data[0]) {
              if (elmt != "_id") {
                this.fields.push({ key: elmt, sortable: true });
              }
            }
            this.totalRows = response.data.data.length;
            this.isBusy = false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.isBusy = false;
        });
    },
  },
  mounted() {
    if (!this.$session.exists() || !this.$session.has("callList")) {
      this.$session.start();
      this.loadCallList();
    } else {
      this.items = this.$session.get("callList");
      this.totalRows = this.items.length;

      if (this.$session.has("filter")) {
        this.filter = this.$session.get("filter");
      }
      var elmt;
      for (elmt in this.items[0]) {
        if (elmt != "_id") {
          this.fields.push({ key: elmt, sortable: true });
        }
      }

      if (this.$session.has("index")) {     
        let n = parseInt(this.$session.get("index"));
        this.currentPage = parseInt(n / this.perPage) + 1;

      }

      this.isBusy = false;
    }
  },
};
</script>